import { render, staticRenderFns } from "./OoaSummary.vue?vue&type=template&id=521d6f14&scoped=true&"
import script from "./OoaSummary.vue?vue&type=script&lang=js&"
export * from "./OoaSummary.vue?vue&type=script&lang=js&"
import style0 from "./OoaSummary.vue?vue&type=style&index=0&id=521d6f14&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521d6f14",
  null
  
)

export default component.exports